function TeamPortal() {
  return <main><h1>Team Portal Page</h1></main>;
}

export default TeamPortal;
